import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (response: any) => {
  return response
}

const getConfigRequest = (entityId: string) => {
  return {
    entityId: entityId,
  }
}

const getConfigOfEntity = (entityId: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.getConfig,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: getConfigRequest(entityId),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getConfigOfEntity }
